import { checkDuplication } from "./checkDuplication"
import { processStudentImport } from "./processStudentImport"
import {
  ImportableCollection,
  ImportParams,
  ImportCallbacks,
  UploadRecord,
  ValidationResult
} from "../types"

const getRecordProcessor = (collection: ImportableCollection) => {
  switch (collection) {
    case ImportableCollection.students: {
      return processStudentImport
    }
    default:
      throw new Error("Target collection not defined or valid.")
  }
}

export const importUsers = async (
  collection: ImportableCollection,
  data: UploadRecord[],
  params: ImportParams,
  callbacks: ImportCallbacks
): Promise<void> => {
  const handleRecordProcess = getRecordProcessor(collection)

  const { districtId } = params
  const { onProgress, onComplete, onError } = callbacks

  const total = data.length
  let processedRecords = 0

  for (let i = 0; i < total; i++) {
    try {
      const record = data[i]

      const email = record.email && record.email.toLowerCase()
      const username =
        (record.username && record.username.toLowerCase()) ?? email
      await checkDuplication(email, username, districtId)

      // This part is unique for specific user type, rest can be applied to any user.
      const generatedPassword = await handleRecordProcess(record, params)
      if (generatedPassword) {
        record.password = generatedPassword
      }

      processedRecords++

      onProgress(processedRecords, processedRecords / total, record)
    } catch (err) {
      if (err === "Request timeout") {
        i > 0 ? (i -= 1) : (i = 0)
      } else {
        processedRecords++

        let msg = ""

        const duplicatesFound = []
        const importErrors: ValidationResult[] = []

        if (err.emailExists || err.usernameExists) {
          if (err.userDoc) {
            duplicatesFound.push(err.userDoc)
          }
          msg = `${err.emailExists ? "Email: " + err.emailExists + "," : ""} ${
            err.usernameExists ? "Username: " + err.usernameExists + "," : ""
          } already exists, in ${
            err.district ? "District: " + err.district : ""
          } ${err.school ? "School: " + err.school : ""} ${
            err.role ? ` as ${err.role}` : ""
          }`
        }

        if (err.error) {
          msg = err.error
        }

        importErrors.push({
          row: i + 1,
          errors: [msg ? msg : err]
        })

        onProgress(processedRecords, processedRecords / total, data[i])
        onError(importErrors, duplicatesFound)
      }
    }
  }

  onComplete()
}
